import { Grid } from '@mui/material';
import Card from '@mui/material/Card';
import {
  blue,
  deepOrange,
  deepPurple,
  green,
  grey,
  orange,
  pink,
  red,
  teal,
} from '@mui/material/colors';
import { useDispatch, useSelector } from 'react-redux';
import { brandColors } from 'types/colors';

import { LabelType, LineChart } from '../../../components/Charts/LineChart';
import MDBox from '../../../components/MDBox';

const FormattedChart = ({
  title,
  datasets,
  isRange,
  isPopUp,
  setChartPopUp,
  sensorId,
  onChartRangeSelect,
  chartRangeButtons,
  compact = false,
  formatTooltipValue,
  preventAllSeriesHidden = false,
}) => {
  const COLORS_FOR_REGULAR_CHARTS = [
    brandColors.BLUE,
    brandColors.GREY,
    brandColors.TURQUOISE,
    orange[400],
    green[300],
    deepOrange[600],
    pink[500],
    teal[600],
    grey[900],
    grey[500],
    blue[600],
  ];
  const dispatch = useDispatch();

  const COLORS_FOR_RANGE_CHARTS = [
    blue[200],
    orange[400],
    green[300],
    deepOrange[600],
    pink[500],
    teal[600],
    red[300],
    orange[400],
    grey[500],
    deepPurple[600],
    blue[600],
  ];
  const chartColors = (isRange === undefined || isRange === false ? COLORS_FOR_REGULAR_CHARTS : COLORS_FOR_RANGE_CHARTS).map(
    (defaultColor, index) => datasets?.[index]?.color || defaultColor,
  );
  const alerts = useSelector(state => state.sensors.alerts);
  const hasAlerts = Object.keys(alerts).length === 0 ? false : true;
  const handleExpand = () => {
    dispatch(
      setChartPopUp({
        title,
        datasets,
        isRange,
      }),
    );
  };
  // console.log('sensorPage/FormattedChart.js re-render');

  return (
    <Grid
      className="chart-container"
      item>
      {/* <Card sx={isPopUp ? { width: '90vw' } : { width: '100%' }}> */}
      <Card sx={compact ? { height: '100%', overflow: 'hidden' } : undefined}>
        <MDBox
          margin={compact ? 0 : 1}
          style={compact ? { height: '100%' } : !isPopUp ? { height: hasAlerts ? '40rem' : '43rem' } : { height: '80vh' }}>
          {/* <MDTypography variant="h8" ml={2} mt={1} mb={-1}>
            {title}
          </MDTypography> */}
          {datasets && (
            <LineChart
              title={title}
              detailed={true}
              horizontalLabels={undefined}
              datasets={datasets}
              isZoomEnabled={true}
              isLineCurved={false}
              xAxis={{ labelType: LabelType.Date, show: true }}
              onExpand={compact ? undefined : handleExpand}
              isPopUp={isPopUp}
              onChartRangeSelect={onChartRangeSelect}
              chartRangeButtons={chartRangeButtons}
              compactAxes={compact}
              colors={chartColors}
              deviceId={sensorId}
              formatTooltipValue={formatTooltipValue}
              preventAllSeriesHidden={preventAllSeriesHidden}
            />
          )}
        </MDBox>
      </Card>
    </Grid>
  );
};

export default FormattedChart;
